import React, { useContext, isValidElement } from 'react';
import { observer } from 'mobx-react';
import { Submenu, Item } from 'react-contexify';
import StackLayout from '../../../../../layouts/stackLayout/StackLayoutComponent';
import Icon from '../../../../icon/IconComponent';
import Text from '../../../../../core/text/TextComponent';
import ContextMenuContext from '../../../dataLayer/contexts/ContextMenuContext';
var ContextSubMenuImplementation = function (_a) {
    var icon = _a.icon, label = _a.label, noTranslation = _a.noTranslation, children = _a.children, hidden = _a.hidden;
    var activeContextMenuVariation = useContext(ContextMenuContext);
    if (hidden) {
        return null;
    }
    return (React.createElement(Item, { onClick: function () {
            return false;
        } },
        React.createElement(Submenu, { arrow: "", label: isValidElement(label) ? label : (React.createElement(StackLayout, { horizontal: true, padding: true, vCenter: true },
                React.createElement(Icon, { icon: icon, variationKey: activeContextMenuVariation.iconVariation, marginRight: true }),
                React.createElement(Text, { variationKey: activeContextMenuVariation.textVariation, noTranslation: noTranslation }, label))) }, children)));
};
export default observer(ContextSubMenuImplementation);
//# sourceMappingURL=ContextSubMenuImplementation.js.map